import { makeStyles } from '@fluentui/react-components';

//TODO: Removing fluentui/north-start dependency. Need proper styling to align it center.
export const useSkeletonCardStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    columnGap: '16px',
    rowGap: '12px',
  },
});
